module.exports = __webpack_public_path__ + "static/media/spiedinitoscanachicken.06f9b172.jpg";